// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__3Nziz","transparent":"Overlay_transparent__3nWxJ","opaque":"Overlay_opaque__2n7lz","empty":"Overlay_empty__3jcvl","loading":"Overlay_loading__D63ll"};